import getClientDocuments from '../../../api/clients/getClientDocuments';

// Ð¢Ð¸Ð¿Ñ ÑÐ°Ð¹Ð»Ð¾Ð² Ð² ÐºÐ°ÑÑÐ¾ÑÐºÐµ ÐºÐ»Ð¸ÐµÐ½ÑÐ° (client_document_types): 1 â ÑÐ´Ð¾ÑÑÐ¾Ð²ÐµÑÐµÐ½Ð¸Ðµ, 2 â Ð¿Ð°ÑÐ¿Ð¾ÑÑ.
// Ð¡ÐºÐ°Ð½ ÑÐ´Ð¾ÑÑÐ¾Ð²ÐµÑÐµÐ½Ð¸Ñ ÐºÐ»Ð°Ð´ÑÑ ÑÑÐ´Ð° ÑÐ°Ð¼ ÐÐÐ Ð¿ÑÐ¸ Ð´Ð¾Ð±Ð°Ð²Ð»ÐµÐ½Ð¸Ð¸ ÐºÐ»Ð¸ÐµÐ½ÑÐ° ÑÐµÑÐµÐ· eGov.
const IDENTITY_TYPE_ID = 1;
const PASSPORT_TYPE_ID = 2;

const latest = (docs, typeId) =>
  (docs || [])
    .filter((doc) => doc?.typeId === typeId && doc?.url)
    .sort((a, b) => (b.id || 0) - (a.id || 0))[0] || null;

// ÐÐ°ÐºÐ¸Ðµ ÑÐºÐ°Ð½Ñ Ð¸Ð· ÐºÐ°ÑÑÐ¾ÑÐºÐ¸ ÐºÐ»Ð¸ÐµÐ½ÑÐ° Ð¿Ð¾Ð´ÑÑÐ°Ð²Ð¸ÑÑ Ð² Ð¿Ð¾Ð»Ñ Ð°Ð½ÐºÐµÑÑ Â«Ð£ÐÐÂ» Ð¸ Â«ÐÐ°ÑÐ¿Ð¾ÑÑ Ð ÐÂ».
export const pickIdentityScans = (docs) => ({
  UDV: latest(docs, IDENTITY_TYPE_ID),
  passportRK: latest(docs, PASSPORT_TYPE_ID),
});

export const fileNameOf = (url) => decodeURIComponent(String(url || '').split('?')[0].split('/').pop() || 'document');

const downloadAsFile = async (doc) => {
  const response = await fetch(doc.url);
  if (!response.ok) throw new Error(`HTTP ${response.status}`);
  const blob = await response.blob();
  return new File([blob], fileNameOf(doc.url), { type: blob.type });
};

// Ð¤Ð¾ÑÐ¾Ð³ÑÐ°ÑÐ¸Ñ ÐºÐ»Ð¸ÐµÐ½ÑÐ° Ð»ÐµÐ¶Ð¸Ñ Ð½Ðµ Ð² Ð´Ð¾ÐºÑÐ¼ÐµÐ½ÑÐ°Ñ, Ð° Ð² Ð°Ð²Ð°ÑÐ°ÑÐµ ÐºÐ°ÑÑÐ¾ÑÐºÐ¸ â ÑÑÐ´Ð° ÐµÑ ÐºÐ»Ð°Ð´ÑÑ
// ÐÐÐ Ð²Ð¼ÐµÑÑÐµ Ñ ÑÐ´Ð¾ÑÑÐ¾Ð²ÐµÑÐµÐ½Ð¸ÐµÐ¼ (ÑÐ½Ð¸Ð¼Ð¾Ðº Ñ ÑÐ°Ð¼Ð¾Ð³Ð¾ Ð´Ð¾ÐºÑÐ¼ÐµÐ½ÑÐ°). ÐÐ°Ð½ÐºÐ¸ ÑÑÐµÐ±ÑÑÑ ÑÐ¾ÑÐ¾ Ð²
// Ð°Ð½ÐºÐµÑÐµ, Ð¸ Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑ Ð¸ÑÐºÐ°Ð» ÐµÐ³Ð¾ ÑÐ°Ð¼, ÑÐ¾ÑÑ Ð¾Ð½Ð¾ ÑÐ¶Ðµ ÐµÑÑÑ.
export const loadClientPhoto = async (photoUrl) => {
  if (!String(photoUrl || '').trim()) return null;
  try {
    return await downloadAsFile({ url: photoUrl });
  } catch (e) {
    return null;
  }
};

// Ð¡ÐºÐ°ÑÐ¸Ð²Ð°ÐµÑ Ð½Ð°Ð¹Ð´ÐµÐ½Ð½ÑÐµ ÑÐºÐ°Ð½Ñ. ÐÐµÐ´Ð¾ÑÑÑÐ¿Ð½ÑÐ¹ ÑÐ°Ð¹Ð» Ð¿ÑÐ¾ÑÑÐ¾ Ð¿ÑÐ¾Ð¿ÑÑÐºÐ°ÐµÐ¼: Ð¿Ð¾Ð»Ðµ Ð¾ÑÑÐ°Ð½ÐµÑÑÑ Ð¿ÑÑÑÑÐ¼,
// Ð¸ Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑ Ð·Ð°Ð³ÑÑÐ·Ð¸Ñ Ð´Ð¾ÐºÑÐ¼ÐµÐ½Ñ ÑÐ°Ð¼, ÐºÐ°Ðº ÑÐ°Ð½ÑÑÐµ.
export const loadIdentityScans = async (clientId) => {
  const res = await getClientDocuments({ userId: clientId });
  const picked = pickIdentityScans(res?.data);
  const files = {};
  await Promise.all(
    Object.entries(picked).map(async ([field, doc]) => {
      if (!doc) return;
      try {
        files[field] = await downloadAsFile(doc);
      } catch (e) {}
    })
  );
  return files;
};
